import { useState, useCallback } from "react";
import api from "../../../api/config";
import { ENDPOINTS } from "../../../api/endpoints";

/**
 * Custom hook for managing Zoom meetings using Zoom Scheduler
 */
export const useZoomMeeting = (lead, zohoId, onSuccess) => {
  const [isZoomModalVisible, setIsZoomModalVisible] = useState(false);
  const [slotError, setSlotError] = useState(null);
  const [schedulerUrl, setSchedulerUrl] = useState(null);
  const [loadingSchedulerUrl, setLoadingSchedulerUrl] = useState(false);

  const fetchSchedulerUrl = useCallback(async () => {
    setLoadingSchedulerUrl(true);
    try {
      const response = await api.get(ENDPOINTS.GET_ZOOM_SCHEDULER_URL);
      if (response.data?.success && response.data?.data?.schedulerUrl) {
        setSchedulerUrl(response.data.data.schedulerUrl);
        setSlotError(null);
        return response.data.data.schedulerUrl;
      } else {
        const errorMsg = response.data?.warning || "Zoom scheduler is not configured. Please contact support.";
        setSlotError(errorMsg);
        setSchedulerUrl(null);
        return null;
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "Failed to load Zoom scheduler. Please try again.";
      setSlotError(errorMessage);
      setSchedulerUrl(null);
      return null;
    } finally {
      setLoadingSchedulerUrl(false);
    }
  }, []);

  const handleScheduleZoomMeeting = useCallback(async () => {
    // First fetch scheduler URL from API
    const url = await fetchSchedulerUrl();
    // Only open modal if URL is successfully fetched
    if (url) {
      setIsZoomModalVisible(true);
    } else {
      // If URL fetch failed, error is already set in state
      // Optionally open modal to show error message
      setIsZoomModalVisible(true);
    }
  }, [fetchSchedulerUrl]);

  const handleZoomModalClose = useCallback(() => {
    setIsZoomModalVisible(false);
    setSlotError(null);
    // Clear scheduler URL so next time it fetches fresh admin-based URL
    setSchedulerUrl(null);
  }, []);

  return {
    isZoomModalVisible,
    handleScheduleZoomMeeting,
    handleZoomModalClose,
    schedulerUrl,
    loadingSchedulerUrl,
    slotError,
    setSlotError,
  };
};

